import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Sidebar } from './Sidebar';
import MobileNav from './MobileNav';
import { CoachSteve } from '../coach-steve/CoachSteve';
import { Footer } from './Footer';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [coachStevePanelOpen, setCoachStevePanelOpen] = useState(false);

  return (
    <div className="flex min-h-screen flex-col bg-cream">
      <div className="flex flex-1 min-h-0">
        {/* Desktop Sidebar - hidden on mobile */}
        <div className="hidden md:block">
          <Sidebar />
        </div>

        {/* Main Content */}
        <main className="flex-1 p-4 md:p-8 pb-24 md:pb-8 overflow-auto">
          {children}
        </main>
      </div>

      {/* Mobile Bottom Navigation - hidden on desktop */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50">
        <MobileNav />
      </div>

      {/* AI Coach tab - opens right-side panel (keeps bottom-right clear for other FAB menus) */}
      <button
        type="button"
        onClick={() => setCoachStevePanelOpen(true)}
        className="fixed right-0 top-1/2 -translate-y-1/2 z-40 flex items-center gap-2 pl-3 pr-4 py-3 rounded-l-full bg-primary text-white shadow-lg hover:bg-primary/90 active:bg-primary/95 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        aria-label="Open AI Coach"
      >
        <MessageCircle className="h-5 w-5" />
        
      </button>

      {/* Coach Steve off-canvas panel - always mounted to preserve chat history */}
      <div
        className={`fixed inset-0 z-50 transition-opacity duration-300 ease-out ${
          coachStevePanelOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        aria-hidden={!coachStevePanelOpen}
      >
        {/* Backdrop */}
        <button
          type="button"
          onClick={() => setCoachStevePanelOpen(false)}
          className="absolute inset-0 bg-black/40 transition-opacity"
          aria-label="Close Coach Steve"
        />
        {/* Panel */}
        <div
          className={`absolute top-0 right-0 h-full w-full max-w-md bg-cream shadow-xl flex flex-col transition-transform duration-300 ease-out ${
            coachStevePanelOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <CoachSteve isPanel onClose={() => setCoachStevePanelOpen(false)} />
        </div>
      </div>

      {/* Footer - desktop only (mobile shows on Dashboard only) */}
      <Footer className="hidden md:block flex-shrink-0" />
    </div>
  );
};

export default MainLayout; 